import { MobileRedirectParams, MobileStoreRedirect } from 'types/mobile-redirects';
import { apiRequest } from '@utils/request';

export async function appStoreVisitRedirect(
	params: MobileRedirectParams,
	options?: { suppressToast?: () => boolean }
): Promise<MobileStoreRedirect> {
	const response = await apiRequest.post('/store/visit', params, options);
	return response.data;
}
